import {
  acquireTokenWithRetry,
  endAndReportPerformanceMeasure,
  reportAuthPageLoad,
  reportError,
  reportInfo,
  startPerformanceMeasure,
} from '@ms/yammer-telemetry';
import { checkThirdPartyCookieSupport, reportThirdPartyCookieEvent } from '@ms/yammer-web-support/dist/cookies';
import { isAuthCookieAvailable } from '@ms/yammer-web-support/dist/hosting';
import { authReload, getUrlRootPath } from '@ms/yammer-web-support/dist/location';
import { hasMetaOsHubContext, notifyAppInitializationFailure } from '@ms/yammer-web-support/dist/metaOsHub';
import { acquireTokenTimeout } from 'bootstrap/auth';
import config from 'bootstrap/config';
import { writeCookies } from 'bootstrap/cookies';
import { getContextWithTelemetry } from 'teams';

const authBootstrap = async () => {
  let endedWithError = false;

  const measure = startPerformanceMeasure('auth_bootstrap');
  const isExecutingInIFrame = window.top !== window.self;
  const isInTeamsApp = await hasMetaOsHubContext();

  try {
    await getContextWithTelemetry();

    const yammerToken = await acquireTokenWithRetry({
      scopes: [config.adal.resources.yammer],
      timeout: acquireTokenTimeout,
      initiator: 'auth_bootstrap',
    });
    const partitioned = !checkThirdPartyCookieSupport();
    writeCookies(yammerToken, partitioned);
  } catch (error: unknown) {
    endedWithError = true;
    reportError({
      error,
      eventProperties: {
        errorCode: 'AuthBootstrapFailed',
        isInTeamsApp,
        isExecutingInIFrame,
      },
    });

    // Since auth bootstrap failed and the app doesn't proceed to main bootstrap, notify app initialization failure to Teams.
    notifyAppInitializationFailure(error);
    throw error;
  } finally {
    reportThirdPartyCookieEvent();
    const urlRootPath = getUrlRootPath(window.location.pathname);

    reportInfo({
      eventName: 'auth_bootstrap_info',
      eventProperties: {
        isExecutingInIFrame,
        isInTeamsApp,
        urlRootPath,
      },
    });

    const eventProperties = { urlRootPath, endedWithError };
    endAndReportPerformanceMeasure({
      ...measure,
      eventProperties: {
        ...measure.eventProperties,
        ...eventProperties,
      },
    });

    reportAuthPageLoad({ eventProperties });
  }

  authReload(!isAuthCookieAvailable());
};

export default authBootstrap;
